var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectFromLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41667 14.0833H11.1667C11.9402 14.0833 12.6821 13.776 13.2291 13.2291C13.776 12.6821 14.0833 11.9402 14.0833 11.1667C14.0833 10.3931 13.776 9.65125 13.2291 9.10427C12.6821 8.55729 11.9402 8.25 11.1667 8.25H4.5C3.72645 8.25 2.98459 7.94271 2.43761 7.39573C1.89062 6.84875 1.58333 6.10688 1.58333 5.33333C1.58333 4.55979 1.89062 3.81792 2.43761 3.27094C2.98459 2.72396 3.72645 2.41667 4.5 2.41667H7.41667M0.75 14.0833C0.75 14.5254 0.925595 14.9493 1.23816 15.2618C1.55072 15.5744 1.97464 15.75 2.41667 15.75C2.85869 15.75 3.28262 15.5744 3.59518 15.2618C3.90774 14.9493 4.08333 14.5254 4.08333 14.0833C4.08333 13.6413 3.90774 13.2174 3.59518 12.9048C3.28262 12.5923 2.85869 12.4167 2.41667 12.4167C1.97464 12.4167 1.55072 12.5923 1.23816 12.9048C0.925595 13.2174 0.75 13.6413 0.75 14.0833ZM10.75 2.41667C10.75 2.85869 10.9256 3.28262 11.2382 3.59518C11.5507 3.90774 11.9746 4.08333 12.4167 4.08333C12.8587 4.08333 13.2826 3.90774 13.5952 3.59518C13.9077 3.28262 14.0833 2.85869 14.0833 2.41667C14.0833 1.97464 13.9077 1.55072 13.5952 1.23816C13.2826 0.925595 12.8587 0.75 12.4167 0.75C11.9746 0.75 11.5507 0.925595 11.2382 1.23816C10.9256 1.55072 10.75 1.97464 10.75 2.41667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFromLocation);
export default __webpack_public_path__ + "static/media/select-from-location.68c5be0245294c320f3b511522451136.svg";
export { ForwardRef as ReactComponent };